import { useCallback } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  KEYWORD_LIST_FETCH_BEGIN,
  KEYWORD_LIST_FETCH_SUCCESS,
  KEYWORD_LIST_FETCH_FAILURE,
  UPDATE_KEYWORD_LIST_FILTER,
} from "./constants";
import _ from "lodash";
import axios from "axios";
import { apiUrl } from "features/configure";
import { enqueueSnackbar } from "features/common/redux/actions";

export const KEYWORD_FILTER_INITIAL_STATE = {
  keywordListFilter: {
    page: 1,
    orderData: { sort: "memtionCount", order: -1 },
    search: "",
  },
};

export function fetchKeywordList({
  entityName,
  filter = KEYWORD_FILTER_INITIAL_STATE.keywordListFilter,
  signal = null,
}) {
  return async (dispatch, getState) => {
    dispatch({
      type: KEYWORD_LIST_FETCH_BEGIN,
    });

    try {
      //   const result = await axios.post(
      //     `${apiUrl}/api/kol/${entityName}/keywordList`,
      //     {
      //       ...filter,
      //     },
      //     {
      //       signal,
      //     }
      //   );
      //   dispatch({
      //     type: KEYWORD_LIST_FETCH_SUCCESS,
      //     data: result.data.keywords,
      //     keywordListCount: result.headers["x-total-count"],
      //   });

      const keywordList = [
        {
          _id: "1",
          keyword: "FAGOT",
          mentionCount: 12345,
          impression: 7.91,
          engagement: 7.78,
        },
      ];

      dispatch({
        type: KEYWORD_LIST_FETCH_SUCCESS,
        data: keywordList,
        keywordListCount: keywordList.length,
      });
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log("Request canceled", err.message);
      } else {
        console.log(err);
        dispatch({
          type: KEYWORD_LIST_FETCH_FAILURE,
        });
        dispatch(
          enqueueSnackbar({
            message: _.get(
              err,
              "response.data.error",
              _.get(err, "response.data.message", "error")
            ),
            options: {
              variant: "error",
            },
          })
        );
      }
    }
  };
}

export function updateKeywordListFilter(data) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_KEYWORD_LIST_FILTER,
      data,
    });
  };
}

export function useFetchKeywordList() {
  const dispatch = useDispatch();

  const {
    keywordList,
    fetchKeywordListPending,
    fetchKeywordListDone,
    keywordListCount,
    keywordListFilter,
  } = useSelector(
    (state) => ({
      keywordList: state.metadesk.keywordList,
      fetchKeywordListPending: state.metadesk.fetchKeywordListPending,
      fetchKeywordListDone: state.metadesk.fetchKeywordListDone,
      keywordListCount: state.metadesk.keywordListCount,
      keywordListFilter: state.metadesk.keywordListFilter,
    }),
    shallowEqual
  );

  const fetchKeywordListAction = useCallback(
    (data) => {
      return dispatch(fetchKeywordList(data));
    },
    [dispatch]
  );

  const updateKeywordListFilterAction = useCallback(
    (data) => {
      return dispatch(updateKeywordListFilter(data));
    },
    [dispatch]
  );

  return {
    keywordList,
    fetchKeywordList: fetchKeywordListAction,
    updateKeywordListFilter: updateKeywordListFilterAction,
    fetchKeywordListDone,
    fetchKeywordListPending,
    keywordListCount,
    keywordListFilter,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case KEYWORD_LIST_FETCH_BEGIN:
      return {
        ...state,
        fetchKeywordListPending: true,
      };
    case KEYWORD_LIST_FETCH_SUCCESS:
      return {
        ...state,
        keywordList: action.data,
        keywordListCount: action.keywordListCount,
        fetchKeywordListDone: true,
        fetchKeywordListPending: false,
      };
    case KEYWORD_LIST_FETCH_FAILURE:
      return {
        ...state,
        fetchKeywordListPending: false,
      };

    case UPDATE_KEYWORD_LIST_FILTER:
      return {
        ...state,
        keywordListFilter: {
          ...KEYWORD_FILTER_INITIAL_STATE.keywordListFilter, // 至少要有初始值
          ...action.data,
        },
      };

    default:
      return state;
  }
}
